import React from 'react'
import { LeftTextRightPicture, Quote, goldColour } from './Home'
import BlueButton from '../components/BlueButton'
import { useNavigate } from 'react-router-dom'
import SmallMusicPlayer from '../components/SmallMusicPlayer'
import { songLyrics } from '../data/songLyrics'
import { CatchPhrase, CallToActionButtons } from './Home'
import T from '../components/Translation'

const AnxietyWhatIf = () => {
  const navigate = useNavigate();

  return (
    <div className="anxiety-what-if">
      <div style={{padding: "20px", display: "flex", justifyContent: "flex-start"}}>
        <BlueButton 
          home
          buttonStyle={{fontSize: "16px", padding: "10px 20px"}}
        />
      </div>

      <LeftTextRightPicture style={{marginTop:"15px", margingBottom:"15px"}} imageStyle={{borderRadius:"100%"}} imageContainerStyle={{alignItems:"center"}} screenChange={1040} imageSource={"/homePictures/mikeAnxiety.png"}>
        <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>
          <CatchPhrase    
            motto = {"Master Anxiety. Find Peace."}
            highlightedWords = {`reMind `}
            mottoEnd = {"Your Growth."}
            catchPhrase = {'Transforming anxiety with the "What If"'}
            highlightedCatchPhrase = {`song affirmation`}
          />
          <SmallMusicPlayer
            secondsOnly={false}
            songSource = {songLyrics[1]?.soundSource}
            title={songLyrics[1]?.title}
            lyrics={songLyrics[1]?.lyrics}
          />
          <CallToActionButtons
            style={{marginTop:"1px"}}  
            goldButtonText = {"More Songs And Topics"}
            blueButtonText = {"Tell Me How You Feel"} 
          />
        </div>
      </LeftTextRightPicture>


      <div style={{padding: "40px"}}>
        <div className={"blue-background"} style={{padding: "30px", marginBottom: "20px"}}>
          <Quote dark author="Jodi Picoult">
            "Anxiety's like a rocking chair. It gives you something to do, but it doesn't get you very far."
          </Quote>
        </div>
        <div style={{margin: "0 auto"}}>
          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            The brain has the ability to change and adjust depending on the environment and situation it finds itself in, this is called neuroplasticity. 
            Believe it or not, this brain skill is responsible for your anxiety cycles since neuroplasticity happens both in positive and negative directions.
          </p>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            If we were to immobilise an arm behind our back, given enough time our brain would assign the resources responsible for that arm to something else. 
            The rule is simple, use it or lose it. Many studies have been done on the subject and there is a wonderful book that I highly recommend called 
            "the brain that changes itself" by Norman Doidge.
          </p>

          <div className={"blue-background"} style={{padding: "40px", marginBottom: "30px"}}>
            <Quote dark author="Norman Doidge">
              "The brain is a far more open system than we ever imagined, and nature has gone very far to help us perceive and take in the world around us. 
              It has given us a brain that survives in a changing world by changing itself."
            </Quote>
          </div>

          <h2 style={{marginBottom: "20px"}}>Understanding Anxiety</h2>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            There are two main types of anxiety, clean and disorderly. Clean anxiety is a healthy and highly important tool, as it keeps us away from harm, 
            by giving us a hint that something is dangerous in the form of an uncomfortable feeling. It also springs us up to action and motivates us when 
            we are called to perform to achieve something important, like studying for a test or before an important work presentation.
          </p>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            The dark side is disorderly anxiety, which is when it starts taking control of our life. Say for example that we can't be around dogs, don't go 
            to parties for fear of judgement, don't swim in the sea for fear of sharks, don't start a business, once it rules us, it can be severely debilitating.
          </p>

          <h2 style={{marginTop: "30px", marginBottom: "20px"}}>The Anxiety Cycle</h2>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            Disorderly anxiety is fed and nourished by avoidance. The more we try to make it go away by avoiding whatever we fear, the stronger it gets. 
            This is known as the anxiety cycle.
          </p>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            Say we are afraid of sharks. We are about to jump into the sea, the discomfort arrives, and even if we know that statistically we are more likely 
            to die in a car accident, and that really, we are safe, we don't go into the water. The result of this action is that we survive, we were not 
            indeed killed by a shark, we were right! The sense of relief is so comfortable and pleasant.
          </p>

          <h2 style={{marginTop: "30px", marginBottom: "20px"}}>Steps to Master Anxiety</h2>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            1. Come up with a reason that matters to you enough to find the will to face the uncomfortable feelings of anxiety. Think of what it is stopping 
            you from doing. Find something important to you that trumps anxiety, that is worth fighting for.
          </p>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            2. Break down the fear into small parts. Then you pick the easiest one and start with that. It is like going to the gym and starting with low 
            weights, and then gradually increasing the difficulty.
          </p>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            3. Remember: Anxiety is uncomfortable but not dangerous. Stay with your fear, don't escape! You can write your anxiety on a scale from 0 to 10. 
            Stay with the emotions, deepen them, learn them and the Anxiety will likely decrease.
          </p>

          <div className={"blue-background"} style={{padding: "40px", marginBottom: "30px"}}>
            <Quote dark author="Stephen Hawking">
              "One of the basic rules of the universe is that nothing is perfect. Perfection simply doesn't exist. Without imperfection, neither you nor I would exist"
            </Quote>
          </div>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            4. Your very own existence depended in principle, on an imperfection. As you learned that you cannot get rid of things in your brain, but only 
            substitute them, you need to turn this unhealthy perfectionism into a powerful learning mindset.
          </p>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            5. All the best athletes have coaches, top players have more than one, they surround themselves with specialists. Don't fall in the arrogant 
            thought that you should do it alone. Take example from the best! Ask a friend or seek the help of a therapist, teamwork will always win.
          </p>

          <div className={"blue-background"} style={{padding: "40px", marginBottom: "30px"}}>
            <Quote dark author="Michael Bianco">
              "Effortless comes from lots of effort placed in intelligent and effective places"
            </Quote>
          </div>

          <h2 style={{marginBottom: "20px"}}>The What If Monster</h2>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            What if I fail? What if it doesn't work out? What if there's no going back? These questions can paralyze us with fear. But remember these lyrics:
          </p>

          <div style={{padding: "20px", backgroundColor: "#f5f5f5", borderRadius: "8px", marginBottom: "20px"}}>
            <p style={{fontSize: "16px", fontStyle: "italic", marginBottom: "10px"}}>
              What if I could Let it go
              What If I could Let it be
              As it needs to be
              And Let it flow
              Fast or slow till it shows
              Its true purpose
            </p>
          </div>

          <p style={{fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            The path forward isn't about eliminating anxiety completely, but transforming it into a tool for growth. As the song suggests, sometimes we need 
            to let go of our need for control and trust in the process.
          </p>

          <div className={"blue-background"} style={{padding: "40px"}}>
            <Quote dark author="soulbruncher">
              "I am ready to commit to my purpose, knowing that it may develop and transform as I grow with it. I am aware that my path may require me to build, 
              create and then let go"
            </Quote>
          </div>

          <p style={{marginTop: "15px", fontSize: "16px", textAlign: "justify", marginBottom: "20px"}}>
            I suggest you learn them, particularly the choruses, hum them in the shower or on the train. Acknowledge the difficulties in the verses, remember you are not alone as thousands of people go through the same thing you go through, and repeat the choruses and the parts you feel most connected to.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AnxietyWhatIf
